import { useNavigate } from 'react-router-dom';
import ContainerTemplate from '../../../../Components/Container/ContainerTemplate';
import AddAnotherRecord from '../../../../Components/Shared/AddAnotherRecord';
import {
  CheckSplvalidationforField,
  fetchInterceptor,
  getCookie,
  getUploadFileName,
  isValid,
  submitSpinner,
  validateDateValue,
} from '../../../../Helper/Utility';
import { UpdateScreenDataController_URL } from '../../../../config/api-endpoints.config';
import {
  buttonText,
  dsaContent,
  dsaControllerErrorMessage,
  EntityWithColumnsNames,
  fileTypeSize,
  initialStateOfFileUpload,
  routeName,
  taskListSectionStatus,
} from '../../../../config/page.config';
import { useAppDispatch, useAppSelector } from '../../../../state/app/hooks';
import { IApplication, IController, IDeleteDocument, SplCharResult } from '../../../../state/models/app.interface';
import { getControllerListDetails } from '../../../../state/slice/ControllerList/ControllerList.slice';
import { getDSADetails, setDSAApplicationDetailsData } from '../../../../state/slice/DSA/DSA.slice';
import {
  getControllerDetails,
  setControllerDetailsData,
} from '../../../../state/slice/DSAAboutController/DSAAboutController.slice';
import { AppDispatch } from '../../../../state/app/store';
import ReviewDateSection from '../../../../Components/Shared/ReviewDateSection';
import { useEffect, useState } from 'react';
import {
  getDeleteDocumentData,
  setDeleteDocumentData,
} from '../../../../state/slice/shared/DeleteDocument/DeleteDocument.slice';
import { ErrorSummary } from 'nhsuk-react-components';
import { getSplCharResEntityDetails } from '../../../../state/slice/SplCharEntityandColumn/SplCharEntityandColumn.slice';

const AddAnotherSLSP: React.FC = () => {
  const navigate = useNavigate();
  const dispatch: AppDispatch = useAppDispatch();

  const authenticationTokenCookie: string = getCookie('authenticationToken')!;
  const { id: dsaApplicationId, aboutControllerSectionStatus } =
    useAppSelector<IApplication>(getDSADetails);

  const { fileUpload, isNewController, isDirtyController, controllerId, saList, fileUploadActive, evidenceFileSummary }: IController =
    useAppSelector(getControllerDetails);
  const { controllerDetailsPage } = useAppSelector(getControllerListDetails);
  const { fileIndex, isDeleted } = useAppSelector(getDeleteDocumentData);
  const [additionalslspsinformationError, setAdditionalslspsinformationError] = useState("");
  const [caseAndEntityListForSplRestriction] = useState(useAppSelector(getSplCharResEntityDetails) || {})
  const saveApplicationDataInStore = (stateData: IApplication) => {
    dispatch(setDSAApplicationDetailsData(stateData));
  };

  const saveControllerDataInStore = (stateData: IController) => {
    dispatch(setControllerDetailsData(stateData));
  };

  const saveDeleteDocumentInStore = (stateData: IDeleteDocument) => {
    dispatch(setDeleteDocumentData(stateData));
  };

  const [diDayError, setDiDayError] = useState(false);
  const [diMonthError, setDiMonthError] = useState(false);
  const [diYearError, setDiYearError] = useState(false);
  const [dateReviewError, setDateReviewError] = useState('');
  const [fileRequiredError, setFileRequiredError] = useState('');

  /* To show the error summary */
  const errorSummaryEL: JSX.Element = (
    <>
      <ErrorSummary aria-labelledby="error-summary-title" role="alert" tabIndex={-1}>
        <ErrorSummary.Title id="error-summary-title">
          {dsaControllerErrorMessage.selectControllerSummary_ErrorMessage}
        </ErrorSummary.Title>
        <ErrorSummary.Body>
          <ErrorSummary.List>
            <ErrorSummary.Item href="#slspDateComplete">{dateReviewError}</ErrorSummary.Item>
            <ErrorSummary.Item>{fileRequiredError ? fileRequiredError : null}</ErrorSummary.Item>
            <ErrorSummary.Item href="#slspNotes">
              {additionalslspsinformationError ? additionalslspsinformationError : null}
            </ErrorSummary.Item>
          </ErrorSummary.List>
        </ErrorSummary.Body>
      </ErrorSummary>
    </>
  );

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    resetError(e);
    let updatedStateofController: IController = {};

    let updatedSAList = { ...saList, [e.target.name]: e.target.value };
    updatedStateofController = { saList: updatedSAList, isDirtyController: true };
    saveControllerDataInStore(updatedStateofController);
  };

  const handleChangeTextarea = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    let updatedStateofController: IController = {};

    let updatedSAList = { ...saList, [e.target.name]: e.target.value };
    updatedStateofController = { saList: updatedSAList, isDirtyController: true };
    saveControllerDataInStore(updatedStateofController);
    resetError(e)
  };

  const resetError = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const valueLength = e.target.value.length;
    if (valueLength >= 1) {
      const { name } = e.target;
      if (
        name === dsaContent.slspDay ||
        name === dsaContent.slspMonth ||
        name === dsaContent.slspYear
      ) {
        setDateReviewError('');
        setDiYearError(false);
        setDiDayError(false);
        setDiMonthError(false);
      }
    }
    if (e.target.name === dsaContent.slspNotes) {
      setAdditionalslspsinformationError("")
    }
  };

  const validateFields = (e: React.MouseEvent<HTMLButtonElement>) => {
    let isValidFields: boolean = true;
    let dateValueError = validateDateValue(
      Number(saList ? saList?.SLSPDay : '0'),
      Number(saList ? saList?.SLSPMonth : '0'),
      Number(saList ? saList?.SLSPYear : '0'),
      false,
      true
    );
    if (dateValueError[0] !== '') {
      setDateReviewError(dateValueError[0]);
      let fields = dateValueError[1].split(',');
      for (let i = 0; i < fields.length; i++) {
        if (fields[i] === dsaContent.dateInputDayField) {
          setDiDayError(true);
        }
        if (fields[i] === dsaContent.dateInputMonthField) {
          setDiMonthError(true);
        }
        if (fields[i] === dsaContent.dateInputYearField) {
          setDiYearError(true);
        }
      }
      isValidFields = false;
    }

    if (!isValid(fileUpload?.find((x) => isValid(x.FileName)))) {
      setFileRequiredError(dsaControllerErrorMessage.UploadFile_ErrorMessage!);
      isValidFields = false;
    }
    if (saList?.SLSPNotes) {
      isValidFields = CheckSplvalidationforField(caseAndEntityListForSplRestriction, EntityWithColumnsNames.approvalsEvidence, EntityWithColumnsNames.additionalISOInformation, EntityWithColumnsNames.additionalSLSPInformationDisplayName, setAdditionalslspsinformationError, saList?.SLSPNotes)
    }



    return isValidFields;
  };

  const handleContinue = (e: React.MouseEvent<HTMLButtonElement>) => {
    const isValid: boolean = validateFields(e);
    if (isValid) {
      submitSpinner(e, handleSubmit);
    } else {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  };

  const handleSubmit = () => {
    if (controllerDetailsPage && !isNewController) {
      const updatedSAList = {
        ...saList,
        SLSPDateComplete: saList
          ? saList.SLSPDay + '/' + saList.SLSPMonth + '/' + saList.SLSPYear
          : '',
      };

      if (isDirtyController) {
        const recentlyUploaded = fileUpload!.filter(file => file?.RecentlyModified! === true);
        const parameters: string = JSON.stringify({
          UserAuthTokenId: authenticationTokenCookie,
          ApplicationId: dsaApplicationId !== '' ? dsaApplicationId : '',
          FileList: recentlyUploaded,
          DataControllerId: controllerId,
          SecurityAssurance: updatedSAList,
          IsSADirty: true,
          SectionStatus: aboutControllerSectionStatus,
        });
        const requestOptions: Object = {
          method: 'POST',
          headers: { 'Content-Type': fileTypeSize.fileTypeJson },
          body: parameters,
        };
        fetchInterceptor(UpdateScreenDataController_URL, requestOptions)
          .then((response) => {
            return response.json();
          })
          .then(() => {
            let sectionStatus: IApplication = {
              aboutControllerSectionStatus: taskListSectionStatus.inProgress,
            };
            saveApplicationDataInStore(sectionStatus);
            navigate(routeName.controllerDetails);
          })
          .catch(() => navigate(routeName.serviceError));
      } else {
        navigate(routeName.controllerDetails);
      }
    } else {
      navigate(routeName.dataProtectionRegistration);
    }
  };

  const deleteRecord = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, index: number) => {
    e.preventDefault();

    const documentData: IDeleteDocument = {
      fileIndex: index,
      fileId: fileUpload![index].FileId!,
      approvalEvidenceID: fileUpload![index].ApprovalEvidenceID!,
      isDeleted: false,
    };
    saveDeleteDocumentInStore(documentData);
    navigate(routeName.deleteDocument);
  };

  const editRecord = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, index: number) => {
    e.preventDefault();
    let updatedState: IController = {};
    updatedState = {
      isDirtyController: true,
      fileUploadActive: index,
      temporaryFileList: fileUpload
    };
    saveControllerDataInStore(updatedState);
    navigate(routeName.dsaSlsp);
  };

  const addAnotherRecord = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, index: number) => {
    e.preventDefault();
    let updatedState: IController = {};
    updatedState = {
      isDirtyController: true,
      fileUploadActive: fileUpload!.length,
      temporaryFileList: fileUpload
    };
    saveControllerDataInStore(updatedState);
    navigate(routeName.dsaSlsp);
  };
  useEffect(() => {
    let updatedState: IController = {};
    updatedState = {
      temporaryFileList: [initialStateOfFileUpload]
    };
    if (isValid(evidenceFileSummary)) {
      let evidenceSummary = evidenceFileSummary?.filter((x) => isValid(x.fileId));
      fileUpload?.map(({ FileName: fileName, ContentType: mimeType }) =>
        isValid(fileName) && (evidenceSummary = [...evidenceSummary!, { fileName, mimeType }])
      );
      updatedState.evidenceFileSummary = evidenceSummary;
    }
    saveControllerDataInStore(updatedState);
  }, [])
  useEffect(() => {
    if (isDeleted) {
      const documentData: IDeleteDocument = {
        isDeleted: false,
      };
      saveDeleteDocumentInStore(documentData);

      let updatedDocData = [...fileUpload!];
      var oldFileName = getUploadFileName(updatedDocData[fileIndex!].FileName!);
      updatedDocData.splice(fileIndex!, 1);
      let updatedState: IController = {};
      updatedState = {
        isDirtyController: true,
        fileUpload: updatedDocData,
        fileUploadActive: fileUpload?.length === 1 ? 0 : fileUploadActive,
        evidenceFileSummary: evidenceFileSummary?.filter((x) => x.fileName !== oldFileName)
      };
      setControllerDetailsData(updatedState);
      saveControllerDataInStore(updatedState);
    }
  }, [isDeleted]);

  return (
    <ContainerTemplate
      title={'SLSP'}
      heading={'Uploaded document(s)'}
      actionButtonText={buttonText.btnSaveAndContinue}
      onActionButtonClick={handleContinue}
    >
      <>
        {(dateReviewError || fileRequiredError || additionalslspsinformationError) && errorSummaryEL}
      </>
      <AddAnotherRecord
        linkTo={routeName.dsaSlsp}
        linkText="Add another document"
        records={fileUpload!} //list of files
        deleteRecord={deleteRecord}
        editRecord={editRecord}
        addAnotherRecord={addAnotherRecord}
      />
      <div className="nhsuk-grid-row">
        <ReviewDateSection
          handleChange={handleChange}
          handleChangeTextarea={handleChangeTextarea}
          dateReviewError={dateReviewError}
          diDayError={diDayError}
          diMonthError={diMonthError}
          diYearError={diYearError}
          additionalInformationError={additionalslspsinformationError}
          data={{
            day: saList ? saList?.SLSPDay : '',
            month: saList ? saList?.SLSPMonth : '',
            year: saList ? saList?.SLSPYear : '',
            notes: saList ? saList?.SLSPNotes : '',
          }}
        />
      </div>
    </ContainerTemplate>
  );
};

export default AddAnotherSLSP;
